import React from "react";
import { useBrandLogo } from "../hooks/useBrandLogo";
import { BrandingStatus } from "../types";
import "./PageLayout.css";

interface PageLayoutProps {
  children: React.ReactNode;
  isCard?: boolean;
  logoURL?: string;
  /**
   * Pages that never wait on `/intent` (e.g. the error page) leave this out and
   * paint the default logo straight away.
   */
  brandingStatus?: BrandingStatus;
}

const DEFAULT_LOGO_CLASSES = "col-6 col-md-5 col-sm-4 mb-2 mb-md-1 logo";
const MERCHANT_LOGO_CLASSES = "col-3 col-md-3 col-sm-4 mb-2 mb-md-1 logo";

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  isCard,
  logoURL,
  brandingStatus = "resolved",
}) => {
  const logoSrc = useBrandLogo(logoURL, brandingStatus);
  const isMerchantLogo = !!logoSrc && logoSrc === logoURL;

  return (
    <div className="d-flex container mt-0 mt-sm-3 mt-md-4 mb-0 mb-sm-3 mb-md-4 p-0 p-sm-1 p-md-2">
      <div className="flex-fill d-none d-md-block"></div>
      <div
        className={`p-2 p-sm-3 p-md-4 flex-fill ${
          isCard ?? true ? "responsive-card" : "responsive-card-modal"
        }`}
      >
        <h2 className="text-center mb-1 mb-sm-1 mb-md-2 logo-slot">
          {/* Holds the height of the default logo so the logo appearing never
              shifts the page, whether it lands early or late. */}
          <span
            className={`${DEFAULT_LOGO_CLASSES} logo-placeholder`}
            data-testid="page-logo-placeholder"
            aria-hidden="true"
          />
          {logoSrc ? (
            <img
              className={isMerchantLogo ? MERCHANT_LOGO_CLASSES : DEFAULT_LOGO_CLASSES}
              src={logoSrc}
              data-testid="page-logo"
              alt=""
            />
          ) : null}
        </h2>
        {children}
      </div>
      <div className="flex-fill d-none d-md-block"></div>
    </div>
  );
};

export default PageLayout;
